var render = function render(){
  var _vm$$route$query, _vm$$route$query2, _vm$$route$query3, _vm$$route$query4, _vm$$route$query5, _vm$$route$query6, _vm$$route$query7, _vm$$route$query8, _vm$$route$query9, _vm$$route$query10, _vm$$route$query11, _vm$$route$query12, _vm$$route$query13, _vm$$route$query14, _vm$$route$query15, _vm$$route$query16, _vm$$route$query17, _vm$$route$query18, _vm$$route$query19, _vm$$route$query20, _vm$$route$query21, _vm$$route$query22, _vm$$route$query23, _vm$$route$query24, _vm$$route$query25, _vm$$route$query26, _vm$$route$query27, _vm$$route$query28, _vm$$route$query29, _vm$$route$query30, _vm$$route$query31, _vm$$route$query32, _vm$$route$query33, _vm$$route$query34, _vm$$route$query35, _vm$$route$query36, _vm$$route$query37, _vm$$route$query38, _vm$assign;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSaveNewTrip.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary btn-menu",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.closeSidebar('create-new-trip');
      }
    }
  }, [_vm._v(" Cancel & Close ")]), _c('b-dropdown', {
    staticClass: "m-0 p-0 btn btn-outline-secondary",
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fa fa-id-card"
        }), _vm._v(" Copy / Paste ")];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "variant": "dark"
    },
    on: {
      "click": _vm.saveDraft
    }
  }, [_vm._v("Copy")]), _c('b-dropdown-item', {
    attrs: {
      "variant": "dark"
    },
    on: {
      "click": _vm.pasteDraft
    }
  }, [_vm._v("Paste")])], 1)], 1)]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('form-wizard', {
    attrs: {
      "title": "",
      "subtitle": "",
      "color": "#334697",
      "step-size": "sm",
      "back-button-text": "Back",
      "next-button-text": "Next Step",
      "finish-button-text": "Save & Close"
    },
    on: {
      "on-complete": _vm.onSaveNewTrip
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Loading Point",
      "label": "1"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', {
    staticClass: "text-primary mb-2"
  }, [_c('strong', [_vm._v("Loading Activity Record")])])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Port of Loading",
      "label-for": "port_of_loading"
    }
  }, [_c('v-select', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query = _vm.$route.query) === null || _vm$$route$query === void 0 ? void 0 : _vm$$route$query.preview,
      "label": "text",
      "options": _vm.positionListPOL,
      "reduce": function reduce(positionListPOL) {
        return positionListPOL.value;
      },
      "placeholder": "Select..."
    },
    model: {
      value: _vm.form.portLoading,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "portLoading", $$v);
      },
      expression: "form.portLoading"
    }
  })], 1)], 1), ['Other'].includes(_vm.form.portLoading) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Other POL",
      "label-for": "POL"
    }
  }, [_c('b-form-input', {
    staticClass: "bg-white",
    attrs: {
      "type": "text",
      "disabled": (_vm$$route$query2 = _vm.$route.query) === null || _vm$$route$query2 === void 0 ? void 0 : _vm$$route$query2.preview,
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.portLoadingOther,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "portLoadingOther", $$v);
      },
      expression: "form.portLoadingOther"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate",
    attrs: {
      "label": "Agent POL",
      "label-for": "agent_pol"
    }
  }, [_c('b-form-input', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query3 = _vm.$route.query) === null || _vm$$route$query3 === void 0 ? void 0 : _vm$$route$query3.preview,
      "type": "text",
      "id": "agent_pol",
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.agentPol,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "agentPol", $$v);
      },
      expression: "form.agentPol"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Is Pol Sts Mv:",
      "label-for": "kind-fleet"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": (_vm$$route$query4 = _vm.$route.query) === null || _vm$$route$query4 === void 0 ? void 0 : _vm$$route$query4.preview,
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.polStsMv,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polStsMv", $$v);
      },
      expression: "form.polStsMv"
    }
  }, [_vm._v(" No / Yes ")])], 1)], 1), _vm.form.polStsMv ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate",
    attrs: {
      "label": "Pol Mv Name",
      "label-for": "pol_mv_name"
    }
  }, [_c('b-form-input', {
    class: {
      'bg-white': _vm.form.polStsMv
    },
    attrs: {
      "type": "text",
      "id": "pol_mv_name",
      "placeholder": "Type Text",
      "disabled": !_vm.form.polStsMv || ((_vm$$route$query5 = _vm.$route.query) === null || _vm$$route$query5 === void 0 ? void 0 : _vm$$route$query5.preview)
    },
    model: {
      value: _vm.form.polMvName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polMvName", $$v);
      },
      expression: "form.polMvName"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pol grab Type",
      "label-for": "pod_grab_type"
    }
  }, [_c('v-select', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query6 = _vm.$route.query) === null || _vm$$route$query6 === void 0 ? void 0 : _vm$$route$query6.preview,
      "label": "text",
      "options": _vm.polGrabTypeOpt,
      "reduce": function reduce(item) {
        return item.value;
      },
      "placeholder": "Select Pol Grab Type"
    },
    model: {
      value: _vm.form.polGrabType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polGrabType", $$v);
      },
      expression: "form.polGrabType"
    }
  })], 1)], 1), _vm.form.polGrabType == 'gearless' ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate",
    attrs: {
      "label": "Pol Fc Name",
      "label-for": "pol_fc_name"
    }
  }, [_c('b-form-input', {
    class: {
      'bg-white': _vm.form.polGrabType == 'gearless'
    },
    attrs: {
      "disabled": _vm.form.polGrabType !== 'gearless' || ((_vm$$route$query7 = _vm.$route.query) === null || _vm$$route$query7 === void 0 ? void 0 : _vm$$route$query7.preview),
      "type": "text",
      "id": "pol_mv_name",
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.polFcName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polFcName", $$v);
      },
      expression: "form.polFcName"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "NOR",
      "label-for": "nor"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query8 = _vm.$route.query) === null || _vm$$route$query8 === void 0 ? void 0 : _vm$$route$query8.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.polNor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polNor", $$v);
      },
      expression: "form.polNor"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "NOA",
      "label-for": "noa"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query9 = _vm.$route.query) === null || _vm$$route$query9 === void 0 ? void 0 : _vm$$route$query9.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.polNoa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polNoa", $$v);
      },
      expression: "form.polNoa"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Anchor Up",
      "label-for": "polAnchorUp"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query10 = _vm.$route.query) === null || _vm$$route$query10 === void 0 ? void 0 : _vm$$route$query10.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polArrivalTime, _vm.form.polAnchorUp, 'Anchor Up', 'Arrival Time', 1);
      }
    },
    model: {
      value: _vm.form.polAnchorUp,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polAnchorUp", $$v);
      },
      expression: "form.polAnchorUp"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 1 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "In Position / Berthing",
      "label-for": "polBerthing"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query11 = _vm.$route.query) === null || _vm$$route$query11 === void 0 ? void 0 : _vm$$route$query11.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polAnchorUp, _vm.form.polBerthing, 'Berthing', 'Anchor Up', 2);
      }
    },
    model: {
      value: _vm.form.polBerthing,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polBerthing", $$v);
      },
      expression: "form.polBerthing"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 2 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Commenced",
      "label-for": "polCommenced"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query12 = _vm.$route.query) === null || _vm$$route$query12 === void 0 ? void 0 : _vm$$route$query12.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polBerthing, _vm.form.polCommenced, 'Commenced', 'Berthing', 3);
      }
    },
    model: {
      value: _vm.form.polCommenced,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polCommenced", $$v);
      },
      expression: "form.polCommenced"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 3 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Completed",
      "label-for": "completed"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query13 = _vm.$route.query) === null || _vm$$route$query13 === void 0 ? void 0 : _vm$$route$query13.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polCommenced, _vm.form.polCompleted, 'Completed', 'Commenced', 4);
      }
    },
    model: {
      value: _vm.form.polCompleted,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polCompleted", $$v);
      },
      expression: "form.polCompleted"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 4 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Draught Survey",
      "label-for": "polDraughtSurvey"
    }
  }, [_c('b-form-input', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query14 = _vm.$route.query) === null || _vm$$route$query14 === void 0 ? void 0 : _vm$$route$query14.preview,
      "type": "number",
      "step": "0.0001",
      "id": "polDraughtSurvey",
      "placeholder": "Type Number"
    },
    on: {
      "change": function change() {
        _vm.form.cargoLoading = _vm.form.polDraughtSurvey;
      }
    },
    model: {
      value: _vm.form.polDraughtSurvey,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polDraughtSurvey", $$v);
      },
      expression: "form.polDraughtSurvey"
    }
  })], 1), _c('span', {
    staticClass: "text-black"
  }, [_vm._v(_vm._s(_vm.form.polDraughtSurvey ? Number(_vm.form.polDraughtSurvey).toLocaleString() : 0))])], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "BL Date",
      "label-for": "blDate"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query15 = _vm.$route.query) === null || _vm$$route$query15 === void 0 ? void 0 : _vm$$route$query15.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.polBlDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polBlDate", $$v);
      },
      expression: "form.polBlDate"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Second Berthing",
      "label-for": "polCastIn"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query16 = _vm.$route.query) === null || _vm$$route$query16 === void 0 ? void 0 : _vm$$route$query16.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.polCastIn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polCastIn", $$v);
      },
      expression: "form.polCastIn"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Cast out",
      "label-for": "polCastOut"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query17 = _vm.$route.query) === null || _vm$$route$query17 === void 0 ? void 0 : _vm$$route$query17.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polCompleted, _vm.form.polCastOut, 'Cast Out', 'Completed', 5);
      }
    },
    model: {
      value: _vm.form.polCastOut,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polCastOut", $$v);
      },
      expression: "form.polCastOut"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "LHV",
      "label-for": "polLhv"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query18 = _vm.$route.query) === null || _vm$$route$query18 === void 0 ? void 0 : _vm$$route$query18.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polCastOut, _vm.form.polLhv, 'LHV', 'Cast Out', 6);
      }
    },
    model: {
      value: _vm.form.polLhv,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polLhv", $$v);
      },
      expression: "form.polLhv"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 6 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Document On Board POL",
      "label-for": "document_on_board"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query19 = _vm.$route.query) === null || _vm$$route$query19 === void 0 ? void 0 : _vm$$route$query19.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polLhv, _vm.form.polDocOnBoard, 'Doc on Board', 'LHV', 7);
      }
    },
    model: {
      value: _vm.form.polDocOnBoard,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polDocOnBoard", $$v);
      },
      expression: "form.polDocOnBoard"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 7 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Departure to POD",
      "label-for": "polDeparture"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker w-100",
    attrs: {
      "disabled": (_vm$$route$query20 = _vm.$route.query) === null || _vm$$route$query20 === void 0 ? void 0 : _vm$$route$query20.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.polDocOnBoard, _vm.form.polDeparture, 'Departure', 'Doc on Board', 8);
      }
    },
    model: {
      value: _vm.form.polDeparture,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polDeparture", $$v);
      },
      expression: "form.polDeparture"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 8 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Remarks",
      "label-for": "polCastIn"
    }
  }, [_c('b-form-textarea', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query21 = _vm.$route.query) === null || _vm$$route$query21 === void 0 ? void 0 : _vm$$route$query21.preview,
      "placeholder": "Type Text..."
    },
    model: {
      value: _vm.form.polRemark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "polRemark", $$v);
      },
      expression: "form.polRemark"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Discharge Point",
      "label": "2"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', {
    staticClass: "text-primary mb-2"
  }, [_c('strong', [_vm._v("Discharge Activity Record")])])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Port of Discharge",
      "label-for": "port_of_discharge"
    }
  }, [_c('v-select', {
    staticClass: "bg-white",
    attrs: {
      "label": "text",
      "options": _vm.positionListPOD,
      "reduce": function reduce(positionListPOD) {
        return positionListPOD.value;
      },
      "placeholder": "Select..."
    },
    model: {
      value: _vm.form.portDischarge,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "portDischarge", $$v);
      },
      expression: "form.portDischarge"
    }
  })], 1)], 1), ['Other'].includes(_vm.form.portDischarge) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Other POD",
      "label-for": "POD"
    }
  }, [_c('b-form-input', {
    staticClass: "bg-white",
    attrs: {
      "type": "text",
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.portDischargeOther,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "portDischargeOther", $$v);
      },
      expression: "form.portDischargeOther"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate",
    attrs: {
      "label": "Agent POD",
      "label-for": "agent_pod"
    }
  }, [_c('b-form-input', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query22 = _vm.$route.query) === null || _vm$$route$query22 === void 0 ? void 0 : _vm$$route$query22.preview,
      "type": "text",
      "id": "agent_pod",
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.agentPod,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "agentPod", $$v);
      },
      expression: "form.agentPod"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Is Pod Sts Mv:",
      "label-for": "pod_sts_mv"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": (_vm$$route$query23 = _vm.$route.query) === null || _vm$$route$query23 === void 0 ? void 0 : _vm$$route$query23.preview,
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.podStsMv,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podStsMv", $$v);
      },
      expression: "form.podStsMv"
    }
  }, [_vm._v(" No / Yes ")])], 1)], 1), _vm.form.podStsMv ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate",
    attrs: {
      "label": "Pod Mv Name",
      "label-for": "pod_mv_name"
    }
  }, [_c('b-form-input', {
    class: {
      'bg-white': _vm.form.podStsMv
    },
    attrs: {
      "type": "text",
      "id": "pol_mv_name",
      "placeholder": "Type Text",
      "disabled": !_vm.form.podStsMv || ((_vm$$route$query24 = _vm.$route.query) === null || _vm$$route$query24 === void 0 ? void 0 : _vm$$route$query24.preview)
    },
    model: {
      value: _vm.form.podMvName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podMvName", $$v);
      },
      expression: "form.podMvName"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pod grab Type",
      "label-for": "pod_grab_type"
    }
  }, [_c('v-select', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query25 = _vm.$route.query) === null || _vm$$route$query25 === void 0 ? void 0 : _vm$$route$query25.preview,
      "label": "text",
      "options": _vm.polGrabTypeOpt,
      "reduce": function reduce(item) {
        return item.value;
      },
      "placeholder": "Select POd Grab Type"
    },
    model: {
      value: _vm.form.podGrabType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podGrabType", $$v);
      },
      expression: "form.podGrabType"
    }
  })], 1)], 1), _vm.form.podGrabType == 'gearless' ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate",
    attrs: {
      "label": "Pod Fc Name",
      "label-for": "pod_fc_name"
    }
  }, [_c('b-form-input', {
    class: {
      'bg-white': _vm.form.podGrabType == 'gearless'
    },
    attrs: {
      "disabled": _vm.form.podGrabType !== 'gearless' || ((_vm$$route$query26 = _vm.$route.query) === null || _vm$$route$query26 === void 0 ? void 0 : _vm$$route$query26.preview),
      "type": "text",
      "id": "pol_mv_name",
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.podFcName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podFcName", $$v);
      },
      expression: "form.podFcName"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate",
    attrs: {
      "label": "Arrival Time POD",
      "label-for": "arrival_time_pod"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query27 = _vm.$route.query) === null || _vm$$route$query27 === void 0 ? void 0 : _vm$$route$query27.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.currentValidTime, _vm.form.podArrivalTime);
      }
    },
    model: {
      value: _vm.form.podArrivalTime,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podArrivalTime", $$v);
      },
      expression: "form.podArrivalTime"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "NOR",
      "label-for": "nor"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query28 = _vm.$route.query) === null || _vm$$route$query28 === void 0 ? void 0 : _vm$$route$query28.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.podNor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podNor", $$v);
      },
      expression: "form.podNor"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "NOA",
      "label-for": "noa"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query29 = _vm.$route.query) === null || _vm$$route$query29 === void 0 ? void 0 : _vm$$route$query29.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.podNoa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podNoa", $$v);
      },
      expression: "form.podNoa"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Anchor Up",
      "label-for": "podAnchorUp"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query30 = _vm.$route.query) === null || _vm$$route$query30 === void 0 ? void 0 : _vm$$route$query30.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.podArrivalTime, _vm.form.podAnchorUp, 'Anchor Up', 'Arrival Time', 11);
      }
    },
    model: {
      value: _vm.form.podAnchorUp,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podAnchorUp", $$v);
      },
      expression: "form.podAnchorUp"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 11 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "In Position / Berthing",
      "label-for": "in_position_pod"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query31 = _vm.$route.query) === null || _vm$$route$query31 === void 0 ? void 0 : _vm$$route$query31.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.podAnchorUp, _vm.form.podBerthing, 'Berthing', 'Anchor Up', 12);
      }
    },
    model: {
      value: _vm.form.podBerthing,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podBerthing", $$v);
      },
      expression: "form.podBerthing"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 12 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Commenced",
      "label-for": "commenced_pod"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query32 = _vm.$route.query) === null || _vm$$route$query32 === void 0 ? void 0 : _vm$$route$query32.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.podBerthing, _vm.form.podCommenced, 'Commenced', 'Berthing', 13);
      }
    },
    model: {
      value: _vm.form.podCommenced,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podCommenced", $$v);
      },
      expression: "form.podCommenced"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 13 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Completed",
      "label-for": "completed_pod"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query33 = _vm.$route.query) === null || _vm$$route$query33 === void 0 ? void 0 : _vm$$route$query33.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.podCommenced, _vm.form.podCompleted, 'Completed', 'Commenced', 14);
      }
    },
    model: {
      value: _vm.form.podCompleted,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podCompleted", $$v);
      },
      expression: "form.podCompleted"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 14 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Draught Survey",
      "label-for": "podDraughtSurvey"
    }
  }, [_c('b-form-input', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query34 = _vm.$route.query) === null || _vm$$route$query34 === void 0 ? void 0 : _vm$$route$query34.preview,
      "type": "number",
      "step": "0.0001",
      "id": "podDraughtSurvey",
      "placeholder": "Type Number"
    },
    model: {
      value: _vm.form.podDraughtSurvey,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podDraughtSurvey", $$v);
      },
      expression: "form.podDraughtSurvey"
    }
  })], 1), _c('span', {
    staticClass: "text-black"
  }, [_vm._v(_vm._s(_vm.form.podDraughtSurvey ? Number(_vm.form.podDraughtSurvey).toLocaleString() : 0))])], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Second Berthing",
      "label-for": "polCastIn"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query35 = _vm.$route.query) === null || _vm$$route$query35 === void 0 ? void 0 : _vm$$route$query35.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.podCastIn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podCastIn", $$v);
      },
      expression: "form.podCastIn"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Cast Out",
      "label-for": "podCastOut"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query36 = _vm.$route.query) === null || _vm$$route$query36 === void 0 ? void 0 : _vm$$route$query36.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    on: {
      "change": function change($event) {
        return _vm.validationTime(_vm.form.podCompleted, _vm.form.podCastOut, 'Cast Out', 'Completed', 15);
      }
    },
    model: {
      value: _vm.form.podCastOut,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podCastOut", $$v);
      },
      expression: "form.podCastOut"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 15 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Departure to POL",
      "label-for": "podDeparture"
    }
  }, [_c('date-picker', {
    staticClass: "custom-date-picker",
    attrs: {
      "disabled": (_vm$$route$query37 = _vm.$route.query) === null || _vm$$route$query37 === void 0 ? void 0 : _vm$$route$query37.preview,
      "value-type": "DD-MM-YYYY HH:mm",
      "type": "datetime",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY HH:mm"
    },
    model: {
      value: _vm.form.podDeparture,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podDeparture", $$v);
      },
      expression: "form.podDeparture"
    }
  })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 18 ? _c('small', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "text-truncate mb-0",
    attrs: {
      "label": "Remarks",
      "label-for": "polCastIn"
    }
  }, [_c('b-form-textarea', {
    staticClass: "bg-white",
    attrs: {
      "disabled": (_vm$$route$query38 = _vm.$route.query) === null || _vm$$route$query38 === void 0 ? void 0 : _vm$$route$query38.preview,
      "placeholder": "Type Text..."
    },
    model: {
      value: _vm.form.podRemark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "podRemark", $$v);
      },
      expression: "form.podRemark"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Review Activiy",
      "label": "3"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex overflow-auto"
  }, [_c('table', {
    staticClass: "table table-sm",
    attrs: {
      "size": "sm"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-truncate",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('th', {
    staticClass: "sticky-col text-center",
    staticStyle: {
      "width": "5px"
    }
  }, [_vm._v("#")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Set as End Trip")]), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Fleet")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Trip Info")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Start Date")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("End Date")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Current Position")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Port Loading")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Port Discharge")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Agent POL")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Agent POD")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("PIC / PE")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Departure")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("ETA")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Updated Today")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Reason")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Idle (Hours)")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Remarks")]), _c('th', {
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Document on Board")]), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "min-width": "170px"
    }
  }, [_vm._v("Cargo Loading")])])]), ((_vm$assign = _vm.assign) === null || _vm$assign === void 0 ? void 0 : _vm$assign.length) > 0 ? _c('tbody', _vm._l(_vm.assign, function (val, index) {
    var _val$reason, _val$portLoading, _val$portDischarge, _val$reason2, _Number;
    return _c('tr', {
      key: index,
      staticClass: "text-truncate",
      staticStyle: {
        "min-width": "200px"
      }
    }, [_c('td', {
      staticClass: "sticky-col text-center",
      staticStyle: {
        "width": "5px",
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          var _vm$assign2;
          (_vm$assign2 = _vm.assign) === null || _vm$assign2 === void 0 ? void 0 : _vm$assign2.splice(index, 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    })]), _c('td', {
      staticClass: "text-center"
    }, [(val === null || val === void 0 ? void 0 : (_val$reason = val.reason) === null || _val$reason === void 0 ? void 0 : _val$reason.name) === 'Unloading' ? _c('b-form-checkbox', {
      attrs: {
        "name": "check-button",
        "switch": "",
        "inline": "",
        "checked": val.isEndTrip
      },
      on: {
        "change": function change($event) {
          return _vm.setOnlyOneIsEndTrip(index);
        }
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "text-truncate text-left"
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm._l(val === null || val === void 0 ? void 0 : val.vehicle, function (v, v_index) {
      return _c('span', {
        key: "h-v-".concat(v_index),
        staticClass: "fs-5 mb-1"
      }, [_c('b-badge', {
        attrs: {
          "variant": "success"
        }
      }, [_vm._v(_vm._s(v.name))])], 1);
    }), _c('b-badge', {
      staticClass: "mb-1",
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(_vm.formatString(val === null || val === void 0 ? void 0 : val.voyageType)))])], 2)]), _c('td', {
      staticClass: "text-truncate"
    }, [val !== null && val !== void 0 && val.tripId ? _c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "d-flex align-items-center text-primary"
    }, [_c('i', {
      staticClass: "fas fa-map-pin mr-2"
    }), _vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : val.polTrip) + " ")]), _c('div', {
      staticClass: "dashed-border"
    }), _c('div', {
      staticClass: "d-flex align-items-center text-primary"
    }, [_c('i', {
      staticClass: "fa fa-map-pin mr-2"
    }), _vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : val.podTrip) + " ")])]) : _c('div', {
      staticClass: "d-flex align-items-center text-danger"
    }, [_c('i', {
      staticClass: "ri-close-circle-line mr-2"
    }), _vm._v(" No trip yet ")])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && val.startDate ? _vm.moment(val.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && val.endDate ? _vm.moment(val.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : val.currentPosition))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : (_val$portLoading = val.portLoading) === null || _val$portLoading === void 0 ? void 0 : _val$portLoading.portName))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : (_val$portDischarge = val.portDischarge) === null || _val$portDischarge === void 0 ? void 0 : _val$portDischarge.portName))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : val.agentPol))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : val.agentPod))]), _c('td', [_c('div', {
      staticClass: "d-flex flex-column"
    }, _vm._l(val.pic, function (v, v_index) {
      return _c('span', {
        key: "h-v-".concat(v_index),
        staticClass: "fs-5 mb-1"
      }, [_c('b-badge', {
        attrs: {
          "variant": "info"
        }
      }, [_vm._v(_vm._s(v === null || v === void 0 ? void 0 : v.name))])], 1);
    }), 0)]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val !== null && val !== void 0 && val.podDeparture ? _vm.moment(val === null || val === void 0 ? void 0 : val.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" - ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(_vm.moment().format('DD MMM YYYY HH:mm')) + " ")]), _c('td', [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : (_val$reason2 = val.reason) === null || _val$reason2 === void 0 ? void 0 : _val$reason2.name))]), _c('td', [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : val.activityDurationFormat))]), _c('td', [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : val.remark))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val.polDocOnBoard ? _vm.moment(val === null || val === void 0 ? void 0 : val.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((_Number = Number((val === null || val === void 0 ? void 0 : val.cargoLoading) || 0)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString()))])]);
  }), 0) : _c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "20"
    }
  }, [_vm._v("No Selected Activity List.")])])])])])])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }